'use strict';

var addProductToCart = require('./product/addToCart'),
	ajax = require('../ajax'),
	page = require('../page'),
	productTile = require('../product-tile'),
	quickview = require('../quickview');

/**
 * @private
 * @function
 * @description Binds the click events to the remove-link and quick-view button
 */
function initializeEvents() {
	if ($('#compare-table').find('.product-tile').length === 1) {
		$('.remove-link').remove();
	}
	$('#compare-table').on('click', '.remove-link', function (e) {
		e.preventDefault();
		ajax.getJson({
			url: this.href,
			callback: function () {
				page.refresh();
			}
		});
	})
	.on('click', '.open-quick-view', function (e) {
		e.preventDefault();
		var url = $(this).closest('.product').find('.thumb-link').attr('href');
		quickview.show({
			url: url,
			source: 'quickview'
		});
	});

	$('#compare-category-list').on('change', function () {
		$(this).closest('form').submit();
	});

	//toggle attribute groups
	$('.attribute-group-title').on('touchstart, click', function () {
		$(this).toggleClass('active');
		$(this).next().toggleClass('active');
	});
}

exports.init = function () {
	productTile.init();
	initializeEvents();
	addProductToCart();
};
